export default {
  subtitle:
    "Tauchen Sie ein in CBAM-Compliance, Kohlenstoffemissionsberechnungen und Branchenbest Practices",
  no_posts: "Keine Artikel verfügbar",
  loading: "Wird geladen...",
  read_time: "{minutes} Min. Lesezeit",
  minute: "Min.",
  share: "Teilen:",
  back_to_list: "Zurück zur Blog-Liste",
  article_not_found: "Artikel nicht gefunden",
  article_not_found_desc: "Entschuldigung, der von Ihnen gesuchte Artikel existiert nicht",
  cta_title: "Bereit, Ihre CBAM-Compliance-Reise zu beginnen?",
  cta_subtitle:
    "Probieren Sie TaxEcoBit jetzt aus, um ganz einfach EU-konforme Kohlenstoffemissionsberichte zu erstellen",
  cta_button: "Jetzt testen",
};
